import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {} from "../../store/actions";

import { Link } from "react-router-dom";

//i18n
import { withTranslation } from "react-i18next";
import SidebarContent from "./SidebarContent";

import logo from "../../assets/images/logo.svg";
import logoLightPng from "../../assets/images/logo-light.png";
import logoLightSvg from "../../assets/images/logo-light.svg";
import logoDark from "../../assets/images/logo-dark.png";

const Sidebar = props => {
  return (
    <React.Fragment>
      <div className="vertical-menu">
        <div className="navbar-brand-box">
          <Link to="/panel/dashboard" className="logo logo-dark">
            <span className="logo-sm">
              <img
                src={"https://api.recoveryfy.in/public/profile/logo.png"}
                alt=""
                height="45"
              />
            </span>
            <span className="logo-lg">
              <img
                src={"https://api.recoveryfy.in/public/profile/logo.png"}
                alt=""
                height="45"
              />
            </span>
          </Link>

          <Link to="/panel/dashboard" className="logo logo-light">
            <span className="logo-sm">
              <img
                src={"https://api.recoveryfy.in/public/profile/logo.png"}
                alt=""
                height="45"
              />
            </span>
            <span className="logo-lg">
              <img
                src={"https://api.recoveryfy.in/public/profile/logo.png"}
                alt=""
                height="45"
              />
            </span>
          </Link>
        </div>
        <div data-simplebar className="h-100">
          {props.type !== "condensed" ? <SidebarContent /> : <SidebarContent />}
        </div>
        <div className="sidebar-background"></div>
      </div>
    </React.Fragment>
  );
};

Sidebar.propTypes = {
  type: PropTypes.string,
};

const mapStateToProps = state => {
  return {
    layout: state.Layout,
  };
};
export default connect(
  mapStateToProps,
  {}
)(withRouter(withTranslation()(Sidebar)));
